
import { defineComponent } from 'vue'
import {
  faTimesCircle,
  faSave,
  faEnvelope,
  faClone,
  faCheck,
  faPaperPlane,
  faFileCircleCheck,
  faFileCircleExclamation,
  faAddressCard,
  faCheckDouble,
  faFileContract,
  faCheckCircle
} from '@fortawesome/free-solid-svg-icons'
import SoftwareHouseDetails from '../components/SoftwareHouseDetails.vue'
import SessionService from '../SessionService'
import api from '@/services/api'
import { Steps } from '@design-system/ui'
import { ShopClientDTO } from '@/interfaces/ShopClientDTO'
import utils from '@/utils'

export default defineComponent({
  name: 'SoftwareHousesEdit',
  components: {
    SoftwareHouseDetails,
    Steps
  },
  data () {
    return {
      loading: false,
      mediatorFee: 0,
      linkHasCopied: false,
      validateByPass: false,
      recoveryProtocolModal: false,
      message: '',
      status: '',
      hidden: true,
      softwareHouseDataLoaded: false,
      softwareHouse: {
        data: '',
        validacoes: '',
        status: ''
      },
      currentStepDetails: {
        index: 0,
        sistema: '',
        message: '',
        class: '',
        icon: faCheckCircle,
        reason: ''
      },
      registerSteps: [
        {
          label: 'Cadastro',
          labelClass: 'text-md',
          icon: faFileCircleExclamation
        },
        {
          label: 'Em andamento',
          labelClass: 'text-md',
          icon: faAddressCard
        },
        {
          label: 'Validações',
          labelClass: 'text-md',
          icon: faCheckDouble
        },
        {
          label: 'Contrato',
          labelClass: 'text-md',
          icon: faFileContract
        },
        {
          label: 'Concluído',
          labelClass: 'text-md',
          icon: faFileCircleCheck
        }
      ],
      buttonIcons: {
        cancel: {
          icon: faTimesCircle
        },
        email: {
          icon: faEnvelope
        },
        sendEmail: {
          icon: faPaperPlane
        },
        save: {
          icon: faSave,
          inconCustomClass: 'filter brightness-0 invert flex items-end'
        },
        copy: {
          icon: faClone
        },
        done: {
          icon: faCheck
        }
      },
      inputMediatorFee: null,
      formValidation: {
        inputMediatorFee: ''
      },
      isFinished: true,
      alreadyRegistered: false,
      toastSuccess: true
    }
  },
  mounted () {
    const session = new SessionService()
    if (!session.rootAccess()) {
      this.$router.push('/painel')
    }
    this.softwareHouseCnpj = this.$route.params.cnpj.toString()
    this.getSoftwareHouse(this.$route.params.cnpj.toString())

    this.onboardingLink = utils.checkUrl()
  },
  methods: {
    async getSoftwareHouse (cnpj: string) {
      this.loading = true
      this.isFinished = false

      try {
        const foundInDatabase = await this.getSoftwareHouseInDatabase(cnpj)
        this.softwareHouse.status = foundInDatabase.status
        this.softwareHouse.data = foundInDatabase
        this.mediatorFee = foundInDatabase.mediatorFee
        this.validateByPass = true

        if (this.softwareHouse.status !== 'cadastro_solicitado') {
          this.alreadyRegistered = true
        }

        if (this.softwareHouse.status === 'cadastro_concluido') {
          this.isFinished = true
        }
      } catch (error) {
        const shopResponse = await api.get<ShopClientDTO>(`/shop/clients/${cnpj}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })

        const shopResponseData = shopResponse.data

        const cnpjSoftwareHouse = shopResponseData.person.juridicPerson?.cnpj
        const softwareHouseMediatorFeeResponse = await api.get(`/software-houses/mediatorfee/${cnpjSoftwareHouse}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        const data = softwareHouseMediatorFeeResponse.data

        this.softwareHouse.data = utils.formatSHOPToSoftwareHouseData(shopResponseData)
        this.softwareHouse.status = 'cadastro_concluido'
        this.mediatorFee = data.mediatorFee
        this.isFinished = true
        this.validateByPass = false
      }

      this.softwareHouseDataLoaded = true
      this.loading = false
    },
    async getSoftwareHouseInDatabase (cnpj: string) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      let softwareHouseData: any = {}
      const preRegister = await api.get(`/pre-register/software-house/${cnpj}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      })

      softwareHouseData.corporateName = preRegister.data.corporateName
      softwareHouseData.cnpj = preRegister.data.cnpj
      softwareHouseData.mediatorFee = preRegister.data.mediatorFee
      softwareHouseData.preRegister = preRegister.data
      softwareHouseData.status = 'cadastro_solicitado'
      try {
        const softwareHouse = await api.get(`/software-houses/${cnpj}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })

        softwareHouse.data.representatives = softwareHouse.data.representatives.sort((representative1, representative2) => {
          if (representative1.isMain === representative2.isMain) {
            return 0
          }
          return representative1.isMain ? -1 : 1
        })

        softwareHouseData = {
          ...softwareHouseData,
          ...softwareHouse.data
        }

        return softwareHouseData
      } catch (error) {
      }
      return softwareHouseData
    },
    getIndex (status: string) {
      switch (status) {
        case 'cadastro_solicitado':
          return 0
        case 'cadastro_andamento':
          return 1
        case 'pendente_validacoes':
          return 2
        case 'assinatura_contrato':
          return 3
        case 'cadastro_concluido':
          return 4
        default:
          return 0
      }
    }
  },
  beforeMount () {
    this.$store.commit('changeActiveMenu', 1)
  }
})
